import Game from "../shell/Game";
import { store } from "../store/store";
import { RollbackType } from "./Tadvance";

export const doUndo = () => {
    const { gameObject } = store.getState();

    if (gameObject.past.length <= 2) { return; }
    // if (Game.Action?.data?.wait) { return; }
    Game.rollback = RollbackType.past;
    // ActionTypes.
    let type = "GAME_OBJECT";
    if (typeof gameObject.present.lastUpdated === "string") {
        // type = gameObject.present.lastUpdated;
        store.dispatch({ type: gameObject.present.lastUpdated + "_UNDO" });
    }
    store.dispatch({ type: type + "_UNDO" });
    // dispatch(ActionCreators.jump(-1));
};

export const doRedo = () => {
    const { gameObject } = store.getState();
    if (gameObject.future.length === 0) { return; }
    // if (Game.Action?.data?.wait) { return; }
    Game.rollback = RollbackType.future;
    let type = "GAME_OBJECT";
    if (typeof gameObject.present.lastUpdated === "string") {
        store.dispatch({ type: gameObject.present.lastUpdated + "_REDO" });
    }
    store.dispatch({ type: type + "_REDO" });

};